/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listTasks} from '../api'

export const useMutationListTasks = createReactQueryMutationHook('listTasks', listTasks)
